import { cn } from 'cn';
import { type PropsWithChildren } from 'react';

type P = PropsWithChildren & ComponentStyling;

export const DataManagementLayout = ({ children, className, style }: P) => (
  <div
    className={cn('mx-4 flex h-full flex-col gap-4', className)}
    style={style}
  >
    {children}
  </div>
);
